var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { Router, NavigationEnd } from "@angular/router";
import { NavController } from "@ionic/angular";
import * as qs from "querystring";
import { CONFIGURATION } from "shared/lib/common/constants";
import { ConfigService } from "../config/config.service";
import * as i0 from "@angular/core";
import * as i1 from "@ionic/angular";
import * as i2 from "@angular/router";
import * as i3 from "../config/config.service";
var RoutingService = /** @class */ (function () {
    function RoutingService(navCtrl, router, config) {
        var _this = this;
        this.navCtrl = navCtrl;
        this.router = router;
        this.config = config;
        this.router.events.subscribe(function (event) {
            if (event instanceof NavigationEnd) {
                _this.previousUrl = _this.currentUrl;
                _this.currentUrl = event.url;
            }
        });
    }
    RoutingService.prototype.getPreviousUrl = function () {
        return this.previousUrl;
    };
    RoutingService.prototype.goBack = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.navCtrl.navigateBack(CONFIGURATION.is_custom_app ? url : __spread([this.config.getOrganization()], url), options);
                return [2 /*return*/];
            });
        });
    };
    RoutingService.prototype.goForward = function (url, options) {
        if (options === void 0) { options = { queryParams: null }; }
        return __awaiter(this, void 0, void 0, function () {
            var relative, restOptions;
            return __generator(this, function (_a) {
                relative = options.relative, restOptions = __rest(options, ["relative"]);
                switch (relative) {
                    case "parent":
                        url = __spread(this.getUrlSegments().slice(0, -1), url);
                        break;
                    case "current":
                        url = __spread(this.getUrlSegments(), url);
                        break;
                    default:
                        if (!CONFIGURATION.is_custom_app) {
                            url = __spread([this.config.getOrganization()], url);
                        }
                }
                return [2 /*return*/, this.navCtrl.navigateForward(url, restOptions)];
            });
        });
    };
    RoutingService.prototype.goRoot = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.navCtrl.navigateRoot(CONFIGURATION.is_custom_app ? url : __spread([this.config.getOrganization()], url), options);
                return [2 /*return*/];
            });
        });
    };
    RoutingService.prototype.getUrlParams = function () {
        return __assign({}, this.router.routerState.snapshot.root.queryParams);
    };
    RoutingService.prototype.getUrlSegments = function () {
        var primary = this.router.parseUrl(this.router.url).root.children.primary;
        return primary ? primary.segments.map(function (_a) {
            var path = _a.path;
            return path;
        }) : [];
    };
    RoutingService.prototype.getParentHref = function () {
        var parts = this.getUrlSegments();
        return parts.slice(0, -1).join("/");
    };
    RoutingService.prototype.isActiveUrl = function (url) {
        var parts = this.getUrlSegments();
        return CONFIGURATION.is_custom_app ? parts.length === 1 && url === parts[0] : parts.length === 2 && url === parts[1];
    };
    RoutingService.prototype.parseUrl = function (url) {
        var _a, _b;
        var _c = __read(url.split("?"), 2), path = _c[0], query = _c[1];
        var segments = path.split("/");
        var key = null;
        var value = null;
        if (query)
            _a = __read(query.split("="), 2), key = _a[0], value = _a[1];
        return {
            segments: segments,
            queryParams: query && (_b = {}, _b[key] = value, _b),
        };
    };
    RoutingService.prototype.createUrl = function (segments, queryParams) {
        return "" + segments.join("/") + (queryParams ? "?" + qs.stringify(queryParams) : "");
    };
    RoutingService.prototype.resetConfig = function () {
        this.router.resetConfig(this.router.config);
    };
    RoutingService.prototype.getRouterEvents = function () {
        return this.router.events;
    };
    RoutingService.ngInjectableDef = i0.defineInjectable({ factory: function RoutingService_Factory() { return new RoutingService(i0.inject(i1.NavController), i0.inject(i2.Router), i0.inject(i3.ConfigService)); }, token: RoutingService, providedIn: "root" });
    return RoutingService;
}());
export { RoutingService };
